import React, { useState } from 'react';
import { I18n } from 'aws-amplify';
import LapDialog from '../../util/laplaceDialog.js';

function SubmitButton(props) {
  const [isAlertInUse, setIsAlertInUse] = useState(false);
  // 案件割り当て済みの設定変更時ダイアログでOKしたときに動く
  const updateSetIsAlertState = async() => {
    setIsAlertInUse(false);
    props.put();
  }
  const click = () => {
    if (props.getInUseByWorkingId()) {
      setIsAlertInUse(true);
      return;
    }
    props.put();
  }
  return(
    <>
      <button className="editButton blue" onClick={click} disabled={props.updateSubmitButtonDisabled()} >{I18n.get('Submit')}</button>
      <LapDialog
        title={''}
        theme={props.theme}
        contentElem={
          <div>
            <p>{I18n.get('There is power plants that have already set up this pattern.')}</p>
            <p>{I18n.get('Do you want to save your edits?')}</p>
          </div>
        }
        firstButtonText={I18n.get('Cancel')}
        firstButtonFunc={() => setIsAlertInUse(false)}
        secondButtonText={I18n.get('Save')}
        secondButtonFunc={() => updateSetIsAlertState()}
        open={isAlertInUse}
        toClose={() => {return}}
      />
    </>
  );
}
export default SubmitButton;
